import React from 'react'
import { Row, Col } from 'reactstrap'
import ItinerarySearch from './search/ItinerarySearch'
import RideBookingSearchResult from './itineraries/RideBookingSearchResult'

const RoundTrip = () => (
  <div>
    <ItinerarySearch />
    <Row>
      <Col >
        <RideBookingSearchResult />
      </Col>
    </Row>
  </div>
)

export default RoundTrip
